const state = {
  isLoading: false,
  consigneeTrack: {},
  locationData: null,
};

export default state;
